<template>
  <span class="search-container">
    <!-- <input placeholder="" v-on:keyup.enter="sendSearchTerm" ref='search' class='search-input' v-model='searchTerms' @blur='hideInput' /> -->
    <input placeholder="" v-on:keyup.enter="sendSearchTerm" ref='search' class='search-input' v-model='searchTerms' />
    <img src="../assets/clear.png" class='clear-search-icon' v-if='searchTermsPresent' @click='clearInput'>
  </span>
</template>

<script>
export default {
  name: 'SearchInput',
  data() {
    return {
      searchTerms: ''
    }
  },
  mounted() {
    this.focusInput();
  },
  methods: {
    focusInput() {
      this.$refs.search.focus();
    },
    sendSearchTerm(event) {
      this.$emit('searched', event.target.value)
    },
    clearInput() {
      this.searchTerms = ''
      this.$emit('searched', null)
      this.focusInput()
    },
    // hideInput: function() {
    //   this.$emit('hideSearchInput')
    //   this.$emit('searched', null)
    // },
  },
  computed: {
    searchTermsPresent: function() {
      return this.searchTerms.length > 0 ? true : false
    },
  }
}
</script>

<style lang='stylus'>

.search-container {
  width: 100%;
}

.search-input {
  border: none;
  border-bottom: 1px solid $white;
  background: $primaryBlue;
  width: 100%;
  transition(all 0.6s ease-in-out);
}

.search-input:focus {
  width: 100%;
}

input.search-input::placeholder {
  color: $white;
}

.clear-search-icon {
  right: 12px;
  height: 15px;
  position: relative;
  cursor: pointer;
}

</style>